const Reflux = require("reflux");
const ProfitableDealOriginsActions = require("../actions/profitable-deal-origins-actions");

const ProfitableDealOriginsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      profitableOrigins: []
    }
  },

  init: function() {
    this.listenTo(ProfitableDealOriginsActions.fetchData, this.onFetchStarted);
    this.listenTo(ProfitableDealOriginsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(ProfitableDealOriginsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        profitableOrigins: data.profitable_origins
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = ProfitableDealOriginsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/profitable-deal-origins-store.js